<template>
  <b-modal
    id="modal-reject-regularization"
    ref="inner-modal"
    title="Reject Regularization Request"
    ok-title="Reject"
    cancel-title="Cancel"
    ok-variant="danger"
    :ok-disabled="!localReason || !localReason.trim()"
    size="md"
    @ok.prevent="handleOk"
    @hidden="handleHidden"
  >
    <b-form v-if="regularization">
      <b-alert variant="warning" show class="mb-2">
        <strong>Employee:</strong> {{ employeeName }}<br>
        <strong>Date:</strong> {{ formatDate(regularization.date || regularization.datestring) }}<br>
        <strong>Issue:</strong> {{ regularization.issue_type || 'Regularization' }}
      </b-alert>
      <b-form-group label="Reason for Rejection" label-for="rejection-reason">
        <b-form-textarea
          id="rejection-reason"
          v-model="localReason"
          rows="4"
          placeholder="Please provide a reason for rejecting this regularization request"
          required
          @input="$emit('update:reason', localReason)"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import moment from 'moment'
import {
  BModal, BForm, BFormGroup, BFormTextarea, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'RejectRegularizationModal',
  components: { BModal, BForm, BFormGroup, BFormTextarea, BAlert },
  props: {
    regularization: { type: Object, default: null },
    employeeName: { type: String, default: '' },
    reason: { type: String, default: '' },
  },
  data() {
    return { localReason: '' }
  },
  watch: {
    reason(val) { this.localReason = val },
  },
  methods: {
    formatDate(date) {
      if (!date) return 'N/A'
      return moment(date).format('DD MMM YYYY')
    },
    handleOk() {
      if (!this.localReason || !this.localReason.trim()) return
      this.$emit('confirm')
    },
    handleHidden() {
      this.localReason = ''
      this.$emit('hidden')
    },
    show() { this.$refs['inner-modal'].show() },
    hide() { this.$refs['inner-modal'].hide() },
  },
}
</script>
